var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{class:_vm.avatarClass,attrs:{"color":'#' + _vm.route.route_color,"size":_vm.size}},[_c(_vm.innerElement,{tag:"component",staticClass:"white--text",class:_vm.textClass},[_vm._v(" "+_vm._s(_vm.route.route_short_name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }